export default {"src":"/_next/static/media/copy.73bc7c8a.svg","height":18,"width":18};